import React, { useEffect, useState } from "react";
import DecorativeSquares from "../components/ui/DecorativeSquares";
import DefaultTab from "../components/Tab/DefaultTab";
import AllCustomers from "./customerspages/AllCustomers"; 
import Add from "../components/button/Add";
import { useNavigate } from "react-router-dom"; 
import { useDispatch } from "react-redux";
import { getAllCustomers } from "../redux/thunks/addCustomerThunk";
import AddCustomerfalse from "../components/Modals/AddCustomerfalse";

const Customers = () => {
  const dispatch = useDispatch();
  const [isRegtrue, setIsRegtrue] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");
  const [pageType, setPageType] = useState("all_customer");
  const navigate = useNavigate();
  const isTrue = localStorage.getItem("is_reg_completed");
  const handleAddNewCustomers = () => {
    if (isTrue === "false") {
      setIsRegtrue(true);
      return;
    }
    navigate("/add-new-customer");
  };

  useEffect(() => {
    dispatch(
      getAllCustomers({
        page,
        search,
        filter,
        page_type: pageType,
      }),
    );
  }, [page, search, filter, pageType, dispatch]);

  return (
    <>
      <section className="max-w-7xl mx-auto mt-8 md:mt-10 ">
        <DecorativeSquares />
        <div className="space-y-2 bg-transparent md:bg-white md:shadow-sm rounded-md mx-auto p-0 lg:p-6 ">
          <div className="text-center md:text-start space-y-2 mb-4 w-full mx-auto relative">
            <h1 className="text-[#191919] text-2xl md:text-3xl font-bold">
              Customers
            </h1>

            {/* Add Button for md+ screens */}
            <div className="hidden md:block absolute top-0 right-0">
              <Add addClickEvent={handleAddNewCustomers} />
            </div>
          </div>
          <div className="block md:hidden border-b mt-2 mb-2 text-gray-100 w-full shadow-xl"></div>
          <div className="mt-4">
            <DefaultTab
              activeTab={pageType}
              onTabChange={(tabId) => {
                setPageType(tabId);
                setPage(1);
              }}
              searchValue={search}
              onSearchChange={(val) => {
                setSearch(val);
                setPage(1);
              }}
              onFilterApply={(val) => {
                setFilter(val);
                setPage(1);
              }}
              tabs={[
                {
                  id: "all_customer",
                  label: "All Customers",
                  content: (
                    <AllCustomers
                      filter={filter}
                      search={search}
                      pageType="all_customer"
                    />
                  ),
                },
                {
                  id: "active_plan_customer",
                  label: "Active",
                  content: (
                    <AllCustomers
                      filter={filter}
                      search={search}
                      pageType="active_plan_customer"
                    />
                  ),
                },
              ]}
            />
          </div>
          <div className="md:hidden">
            <Add
              addClickEvent={handleAddNewCustomers}
              extraClasses="fixed bottom-28 right-4 sm:bottom-20 sm:right-6 z-40"
            />
          </div>
        </div>
      </section>

      {isRegtrue && (
        <AddCustomerfalse
          open={isRegtrue}
          onClose={() => setIsRegtrue(false)}
          onConfirm={() => {
            setIsRegtrue(true);
            navigate("/set-up");
          }}
        />
      )}
    </>
  );
};

export default Customers;
